import React, { useEffect, useState } from 'react';
import { Table, Button, DatePicker, Form, Input, Modal, Popover, Checkbox } from 'antd';
import { get_locomotive_fuel_tank, update_locomotive_fuel_tank } from '../../Services/fuel management';
import moment from 'moment';
import { useHistory } from 'react-router-dom';

const LocomotiveFM = ({ currentTab }) => {

    const history = useHistory();
    const [searchTextEqiup, setSearchTextEqiup] = useState("")
    const [searchTextWo, setSearchTextWo] = useState("")
    const [searchTextGallons, setSearchTextGallons] = useState("")
    const [form_correctionDate] = Form.useForm();
    const [form_srvGallons] = Form.useForm();
    const [data, setData] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState({
        type: null,
        flag: false,
    });
    const [filters, setFilters] = useState({
        EquipUID: [],
        SvrcGallons: [],
        WOID: [],
        CrtDate: null,
        WorkCompleted: null,
    })
    const [selectedFilterValues, setSelectedFilterValues] = useState({
        EquipUID: [],
        SvrcGallons: [],
        WOID: [],
        CrtDate: null,
        WorkCompleted: null,
    })
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });


    const fetchData = async () => {
        let response = await get_locomotive_fuel_tank(filters);
        if (response?.httpStatus === 200) setData(response?.data);
    };

    const onFinish = async (values) => {
        const bodyForCorrectionDate = {
            TaskHistID: selectedRow?.TaskHistID,
            CrtDate: values?.CrtDate ? values?.CrtDate?.format('YYYY-MM-DD') : undefined,
        };
        const bodyForServiceGallons = {
            TaskHistID: selectedRow?.TaskHistID,
            CrtSrvcGallons: values?.CrtSrvcGallons || undefined,
        };

        const result = await update_locomotive_fuel_tank(
            isModalOpen.type === 'correctionDate' ? bodyForCorrectionDate : bodyForServiceGallons
        );

        if (result?.httpStatus === 200) {
            form_correctionDate.resetFields();
            form_srvGallons.resetFields();
            setIsModalOpen({ type: null, flag: false });
            setSelectedRow(null);
            fetchData();
        }
    };
    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams({
            pagination,
            filters,
        });
    };


    const columns = [
        {
            title: 'Equip ID',
            dataIndex: 'EquipID',
            key: 'EquipID',
            width: 150,
            filteredValue: filters?.EquipUID || [],
            render: (_, record) =>
                record?.EquipWorkOrder?.EquipID ? (
                    <a
                        onClick={() =>
                            history.push('/LocomotiveEdit', {
                                type: 'Edit',
                                data: { id: record?.EquipWorkOrder?.EquipID },
                            })
                        }
                    >
                        {record?.EquipWorkOrder?.EquipMaster?.EquipUID || '-'}
                    </a>
                ) : '-',
            filterDropdown: () => {
                const filteredFilters = data
                    .map((record) => record?.EquipWorkOrder?.EquipMaster?.EquipUID || '-')
                    .filter((equipUID, index, self) => self.indexOf(equipUID) === index) // Remove duplicates
                    .filter((equipUID) => equipUID.toLowerCase().includes(searchTextEqiup.toLowerCase())); // Apply search
                return (
                    <div style={{ padding: 8 }}>
                        <Input
                            placeholder="Search Equip ID"
                            value={searchTextEqiup}
                            onChange={(e) => setSearchTextEqiup(e.target.value)}
                            style={{ marginBottom: 8, display: 'block' }}
                        />
                        <div style={{ maxHeight: 300, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: "10px" }}>
                            {filteredFilters.map((filter) => (
                                <Checkbox
                                    key={filter}
                                    checked={selectedFilterValues?.EquipUID?.indexOf(filter) >= 0}
                                    style={{ margin: 0 }}
                                    onChange={() => {
                                        const nextSelectedKeys =
                                            selectedFilterValues?.EquipUID?.indexOf(filter) >= 0
                                                ? selectedFilterValues?.EquipUID?.filter((key) => key !== filter)
                                                : [...selectedFilterValues?.EquipUID, filter];
                                        setSelectedFilterValues((prev) => ({ ...prev, EquipUID: nextSelectedKeys }));
                                    }}
                                >
                                    {filter}
                                </Checkbox>
                            ))}
                        </div>
                        <div style={{ marginTop: 8 }}>
                            <Button
                                type="primary"
                                onClick={() => {
                                    setFilters((prev) => ({ ...prev, EquipUID: selectedFilterValues?.EquipUID?.length ? selectedFilterValues?.EquipUID : [] }))
                                }                                }
                                size="small"
                                style={{ fontSize: "11px", width: 90, marginRight: 8, background: "#2863AD" }}
                            >
                                Filter
                            </Button>
                            <Button
                                onClick={() => {
                                    setSelectedFilterValues((prev) => ({ ...prev, EquipUID: [] }))
                                    setSearchTextEqiup('')
                                }
                                }
                                size="small"
                                style={{ fontSize: "11px", width: 90 }}
                            >
                                Clear
                            </Button>
                        </div>
                    </div >
                );
            },
        },
        {
            title: 'Date Completed',
            dataIndex: 'WorkCompleted',
            key: 'WorkCompleted',
            width: 180,
            filteredValue: filters?.WorkCompleted || null,
            render: (_, record) =>
                record?.EquipWOTaskHist?.WorkCompleted
                    ? moment(record?.EquipWOTaskHist?.WorkCompleted).utc().format('MM-DD-YYYY')
                    : 'N/A',
            filterDropdown: () => (
                <div style={{ padding: 8 }}>
                    <DatePicker
                        value={selectedFilterValues?.WorkCompleted ? moment(selectedFilterValues?.WorkCompleted) : null}
                        onChange={(date) => {
                            if (date) setSelectedFilterValues((prev) => ({ ...prev, WorkCompleted: date?.format('MM-DD-YYYY') }));
                            else setSelectedFilterValues((prev) => ({ ...prev, WorkCompleted: null }));
                        }}
                        format={"MM-DD-YYYY"}
                        style={{ marginBottom: 8, display: 'block' }}
                    />
                    <div style={{ textAlign: 'right' }}>
                        <Button
                            type="primary"
                            onClick={() => {
                                setFilters((prev) => ({ ...prev, WorkCompleted: selectedFilterValues?.WorkCompleted ? selectedFilterValues?.WorkCompleted : null }));
                            }}
                            size="small"
                            style={{ fontSize: "11px", width: 90, marginRight: 8, background: "#2863AD" }}
                        >
                            Filter
                        </Button>
                        <Button
                            onClick={() => {
                                setSelectedFilterValues((prev) => ({ ...prev, WorkCompleted: null }));
                            }}
                            size="small"
                            style={{ fontSize: "11px", width: 90 }}
                        >
                            Clear
                        </Button>
                    </div>
                </div>
            ),
        },
        {
            title: 'Correction Date',
            dataIndex: 'CrtDate',
            key: 'CrtDate',
            width: 180,
            filteredValue: filters?.CrtDate || null,
            render: (_, record) =>
                record?.EquipWOTaskHist?.CrtDate
                    ? moment(record?.EquipWOTaskHist?.CrtDate).utc().format('MM-DD-YYYY')
                    : 'N/A',
            filterDropdown: () => (
                <div style={{ padding: 8 }}>
                    <DatePicker
                        value={selectedFilterValues?.CrtDate ? moment(selectedFilterValues?.CrtDate) : null}
                        onChange={(date) => {
                            setSelectedFilterValues((prev) => ({ ...prev, CrtDate: date?.format('MM-DD-YYYY') }));
                        }}
                        format={"MM-DD-YYYY"}
                        style={{ marginBottom: 8, display: 'block' }}
                    />
                    <div style={{ textAlign: 'right' }}>
                        <Button
                            type="primary"
                            onClick={() => {
                                setFilters((prev) => ({ ...prev, CrtDate: selectedFilterValues?.CrtDate ? selectedFilterValues?.CrtDate : null }));
                            }}
                            size="small"
                            style={{ fontSize: "11px", width: 90, marginRight: 8, background: "#2863AD" }}
                        >
                            Filter
                        </Button>
                        <Button
                            onClick={() => {
                                setSelectedFilterValues((prev) => ({ ...prev, CrtDate: null }));
                            }}
                            size="small"
                            style={{ fontSize: "11px", width: 90 }}
                        >
                            Clear
                        </Button>
                    </div>
                </div>
            ),
        },
        {
            title: 'Srvc Gallon',
            dataIndex: 'SrvcGallons',
            key: 'SrvcGallons',
            width: 150,
            filteredValue: filters?.SvrcGallons || null,
            render: (_, record) => record?.EquipWOTaskHist?.CrtSrvcGallons || record?.EquipWOTaskHist?.SvrcGallons || 'N/A',
            filterDropdown: () => {

                const filteredFilters = data
                    .map((record) => record?.EquipWOTaskHist?.CrtSrvcGallons || record?.EquipWOTaskHist?.SvrcGallons || 'N/A')
                    .filter((gallon, index, self) => self.indexOf(gallon) === index)
                    .filter((gallon) => {
                        const gallonStr = String(gallon).toLowerCase();
                        return gallonStr.includes(searchTextGallons.toLowerCase());
                    });
                return (
                    <div style={{ padding: 8 }}>
                        <Input
                            placeholder="Search Srvc Gallon"
                            value={searchTextGallons}
                            onChange={(e) => setSearchTextGallons(e.target.value)}
                            style={{ marginBottom: 8, display: 'block' }}
                        />
                        <div style={{ maxHeight: 300, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            {filteredFilters.map((filter) => (
                                <Checkbox
                                    key={filter}
                                    checked={selectedFilterValues?.SvrcGallons?.indexOf(filter) >= 0}
                                    style={{ margin: 0 }}
                                    onChange={() => {
                                        const nextSelectedKeys =
                                            selectedFilterValues?.SvrcGallons?.indexOf(filter) >= 0
                                                ? selectedFilterValues?.SvrcGallons?.filter((key) => key !== filter)
                                                : [...selectedFilterValues?.SvrcGallons, filter];
                                        setSelectedFilterValues((prev) => ({ ...prev, SvrcGallons: nextSelectedKeys }));
                                    }}
                                >
                                    {filter}
                                </Checkbox>
                            ))}
                        </div>
                        <div style={{ marginTop: 8 }}>
                            <Button
                                type="primary"
                                onClick={() => {
                                    setFilters((prev) => ({ ...prev, SvrcGallons: selectedFilterValues?.SvrcGallons?.length ? selectedFilterValues?.SvrcGallons : [] }));
                                }}
                                size="small"
                                style={{ fontSize: '11px', width: 90, marginRight: 8, background: '#2863AD' }}
                            >
                                Filter
                            </Button>
                            <Button
                                onClick={() => {
                                    setSearchTextGallons('')
                                    setSelectedFilterValues((prev) => ({ ...prev, SvrcGallons: [] }))
                                }
                                }
                                size="small"
                                style={{ fontSize: '11px', width: 90 }}
                            >
                                Clear
                            </Button>
                        </div>
                    </div>
                );
            },
        },
        {
            title: 'Notes',
            dataIndex: 'Notes',
            key: 'Notes',
            render: (_, record) => record?.EquipWOTaskHist?.Notes || 'N/A',
        },
        {
            title: 'WO ID',
            dataIndex: 'WOID',
            key: 'WOID',
            render: (_, record) =>
                record?.WOID ? (
                    <a
                        onClick={() =>
                            history.push('/Locomotive-work-order-edit', {
                                id: record?.WOID,
                            })
                        }
                    >
                        {record?.WOID}
                    </a>
                ) : '-',
            filteredValue: filters?.WOID || [],
            filterDropdown: () => {

                const filteredFilters = data
                    .map((record) => record?.WOID || '-')
                    .filter((woID, index, self) => self.indexOf(woID) === index)
                    .filter((woID) => {
                        const woIDSTR = String(woID).toLowerCase();
                        return woIDSTR.includes(searchTextWo.toLowerCase());
                    });

                return (
                    <div style={{ padding: 8 }}>
                        <Input
                            placeholder="Search WO ID"
                            value={searchTextWo}
                            onChange={(e) => setSearchTextWo(e.target.value)}
                            style={{ marginBottom: 8, display: 'block' }}
                        />
                        <div style={{ maxHeight: 300, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            {filteredFilters.map((filter) => (
                                <Checkbox
                                    key={filter}
                                    checked={selectedFilterValues?.WOID?.indexOf(filter) >= 0}
                                    style={{ margin: 0 }}
                                    onChange={() => {
                                        const nextSelectedKeys =
                                            selectedFilterValues?.WOID?.indexOf(filter) >= 0
                                                ? selectedFilterValues?.WOID?.filter((key) => key !== filter)
                                                : [...selectedFilterValues?.WOID, filter];
                                        setSelectedFilterValues((prev) => ({ ...prev, WOID: nextSelectedKeys }));
                                    }}
                                >
                                    {filter}
                                </Checkbox>
                            ))}
                        </div>
                        <div style={{ marginTop: 8 }}>
                            <Button
                                type="primary"
                                onClick={() => {
                                    setFilters((prev) => ({ ...prev, WOID: selectedFilterValues?.WOID?.length ? selectedFilterValues?.WOID : [] }));
                                }}
                                size="small"
                                style={{ fontSize: '11px', width: 90, marginRight: 8, background: '#2863AD' }}
                            >
                                Filter
                            </Button>
                            <Button
                                onClick={() => {
                                    setSelectedFilterValues((prev) => ({ ...prev, WOID: [] }));
                                    setSearchTextWo('')
                                }}
                                size="small"
                                style={{ fontSize: '11px', width: 90 }}
                            >
                                Clear
                            </Button>
                        </div>
                    </div>
                );
            },
        },
        {
            title: 'Actions',
            key: 'action',
            render: (_, row) => (
                <Popover content={
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "center", justifyContent: "center" }}>
                        <span>Edit</span>
                        <button
                            style={{ fontSize: "10px", background: "#2863AD", color: "white", borderRadius: "8px", border: "none", width: "100%", height: "35px", cursor: "pointer" }}
                            onClick={() => {
                                setIsModalOpen({ type: "correctionDate", flag: true })
                                form_correctionDate.setFieldsValue({ CrtDate: row?.EquipWOTaskHist?.CrtDate ? moment(row?.EquipWOTaskHist?.CrtDate)?.utc() : null })
                                setSelectedRow(row)
                            }}>
                            Correction date
                        </button>
                        <button
                            style={{ fontSize: "10px", background: "#2863AD", color: "white", borderRadius: "8px", border: "none", width: "100%", height: "35px", cursor: "pointer" }}
                            onClick={() => {
                                setIsModalOpen({ type: "serviceGallons", flag: true })
                                form_srvGallons.setFieldsValue({ CrtSrvcGallons: row?.EquipWOTaskHist?.CrtSrvcGallons || null })
                                setSelectedRow(row)
                            }}
                        >Service Gallons</button>
                    </div>
                }>
                    <span className="EditIcon" style={{ cursor: "pointer" }} />
                </Popover>
            ),
        },
    ];

    useEffect(() => {
        if (currentTab === '2') fetchData();
    }, [currentTab, filters?.CrtDate, filters?.SvrcGallons, filters?.EquipUID, filters?.WOID, filters?.WorkCompleted]);

    return (
        <div>
            <div style={{ "display": "flex", "justifyContent": "flex-end", "alignItems": "center" }}>
                <button
                    onClick={() => {
                        setFilters({
                            EquipUID: [],
                            SvrcGallons: [],
                            WOID: [],
                            CrtDate: null,
                            WorkCompleted: null,
                        })
                        setSelectedFilterValues({
                            EquipUID: [],
                            SvrcGallons: [],
                            WOID: [],
                            CrtDate: null,
                            WorkCompleted: null,
                        })
                    }}
                    style={{ background: "#2863AD", color: "white", borderRadius: "8px", border: "none", width: "15%", marginBottom: "10px", height: "35px", cursor: "pointer", fontSize: "12px" }}>
                    Reset Filters
                </button>
            </div>
            <Table
                columns={columns}
                dataSource={data}
                rowKey={(record) => record?.TaskHistID}
                pagination={tableParams.pagination}
                onChange={handleTableChange}
            />
            <Modal
                open={isModalOpen.type === 'correctionDate' && isModalOpen.flag}
                onCancel={() => {
                    form_correctionDate.resetFields();
                    setIsModalOpen({ type: null, flag: false });
                    setSelectedRow(null);
                }}
                footer={null}
                title="Edit Correction Date"
            >
                <Form form={form_correctionDate} layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        name="CrtDate"
                        label="Correction Date"
                        rules={[{ required: true, message: 'Please select a date!' }]}
                    >
                        <DatePicker style={{ width: '100%' }} format="MM-DD-YYYY" />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" block>
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
            <Modal
                open={isModalOpen.type === "serviceGallons" && isModalOpen.flag}
                onCancel={() => {
                    form_srvGallons?.resetFields()
                    setIsModalOpen({ type: "serviceGallons", flag: false })
                    setSelectedRow(null)
                }}
                footer={null}
                title={"Edit Service Gallons"}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                    <span>Service Gallons</span>
                    <span>{selectedRow?.SvrcGallons || "N/A"}</span>
                    <Form form={form_srvGallons} layout="vertical" onFinish={onFinish}>
                        <Form.Item
                            name="CrtSrvcGallons"
                            label="Corrected Service Gallons"
                            rules={[{ required: true, message: 'Please type service gallons!' }]}
                        >
                            <Input placeholder='Enter corrected service gallons' />
                        </Form.Item>
                        <Form.Item>
                            <button
                                type='submit'
                                style={{ background: "#2863AD", color: "white", borderRadius: "8px", border: "none", width: "100%", height: "40px", cursor: "pointer" }}>
                                Submit
                            </button>
                        </Form.Item>
                    </Form>
                </div>

            </Modal>
        </div>
    );
};

export default LocomotiveFM;
